.layout {
    display: flex;
    align-items: stretch;
    flex-grow: 1;
}

.configsPanel {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: var(--exo-spacing-large);
    min-width: 0;
    overflow-y: auto;
    gap: var(--exo-spacing-standard);
}

.empty {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: var(--exo-spacing-2x-large) var(--exo-spacing-large);
    text-align: center;
}
